<template>
  <div :class="isDipatch && isDipatchStyle?'form-group base_form-group':'base-control'">
    <div
      v-if="label"
      :style="labelStyle"
      v-text="label"
      :title="label"
      :class="rootClass"
      class="base-control__title"
    ></div>
    <div v-if="toolTipText">
      <el-tooltip placement="top" :content="toolTipText">
        <i class="el-icon-warning"></i>
      </el-tooltip>
    </div>
    <div
      :style="inputStyle"
      :class="this.isDipatch && this.isDipatchStyle?'col-md-8':`base-control__input-${this.styleType} base-control__input`"
    >
      <template v-if="!readOnly">
        <div class="base-control__input-el">
          <slot name="control"></slot>
        </div>
      </template>
      <template v-else>
        <div v-if="isHtml" :class=" this.isWrap ? 'base-control__value_wrap' : 'base-control__value'">
          <slot name="htmlShow"></slot>
        </div>
        <div v-else-if="splitValue">
          <div v-if="showInputValue" class="base-control-split-value">
            <p v-for="item in showInputValue.split(',')" :key="item">{{item}}</p>
          </div>
          <div v-else :title="showInputValue" :class=" this.isWrap ? 'base-control__value_wrap' : 'base-control__value'" v-html="showInputValue"></div>
        </div>
        <div v-else :title="showInputValue" :class=" this.isWrap ? 'base-control__value_wrap' : 'base-control__value'" v-html="showInputValue"></div>
      </template>
      <slot name="dialog"></slot>
    </div>
  </div>
</template>

<script>
import { layout } from "./../props-config";
export default {
  name: "base-layout",
  props: {
    ...layout,
    labelPaddingRight:{
      type: Number,
      default: 32
    },
    isHtml: {
      type: Boolean,
      default: false
    },
    splitValue: {
      type: Boolean,
      default: false
    },
    toolTipText: {
      type: String,
      default: ''
    },
    whiteSpace: {
      type: Boolean,
      default: false
    },
    isWrap: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    rootClass() {
      let className = "";
      this.isDipatch && this.isDipatchStyle ? (className += "col-md-4") : null;
      this.isRequire ? (className += "isRequire") : null;
      return className;
    },
    showInputValue() {
      if(this.styleType === 2 && this.readOnly && !this.value && this.value !== 0) return '--'
      return this.value || this.value === 0?  this.value.toString(): '';
    },
    labelStyle() {
      const labelWidth = this.labelWidth;
      let _width;
      if (isNaN(Number(labelWidth)) === true) {
        _width = labelWidth;
      } else {
        _width = `${labelWidth}px`;
      }
      return {
        "min-width": this.isDipatch && this.isDipatchStyle ? "auto" : _width,
        textAlign: this.textAlign,
        "padding-right": this.labelPaddingRight + "px",
        "color":this.readOnly ? '#888': '',
        "white-space": this.whiteSpace ? 'normal' : 'none',
        "width": this.whiteSpace ? _width : 'none',
        'font-size': this.whiteSpace ? '13px' : 'none'
      };
    },
    inputStyle() {
      return {
        flex: 1
      };
      const labelWidth = this.labelWidth;
      if (!this.label) {
        return {
          width: "100%"
        };
      } else {
        return {
          width: `calc(100% - ${labelWidth}px)`
        };
      }
    }
  },
  data() {
    return {};
  }
};
</script>

<style scoped lang="scss">
@import "src/sass/index";
.base_form-group {
  overflow: hidden;
  /* display: inline-flex; */
}
.base-control {
  $_fontSize: 14px;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  min-height: 40px;
  margin-bottom: 10px;
  .base-control__input-1 {
    .base-control__value, .base-control__value_wrap {
      position: relative;
      &::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        border: 1px solid #999;
        border-top: none;
        height: 0;
      }
    }
  }
  .base-control__input-2 {
    .base-control__value {
      overflow: initial;
      text-overflow: initial;
      white-space: pre-wrap;
      height: auto;
      line-height: 1.3;
    }
  }
  .base-control__input-3 {
    padding: 0 !important;
  }
  font-size: $_fontSize;
  .base-control__value {
  }
  /* 标题 */
  .base-control__title {
    padding-right: 32px;
    text-align: right;
    white-space: nowrap;
    // font-size: $_fontSize;
    &.isRequire {
      &:before {
        display: inline-block;
        content: "*";
        height: 100%;
        line-height: 1;
        vertical-align: middle;
        color: red;
      }
    }
  }

  .base-control__input {
    padding: 0 16px;
  }
  .base-control__value {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 21px;
    line-height: 21px;
  }
  .base-control__value_wrap {
    overflow: inherit;
    white-space: pre-wrap;
    height: 42px;
    line-height: 21px;
  }
  .el-autocomplete {
    width: 100%;
  }
}
table .base-control {
  .base-control__input {
    padding: 0;
  }
}
.base-control-split-value {
  padding-bottom: 2px;
  border-bottom: 1px solid #999;
  font-size: 15px;
}
</style>
